module.exports = __webpack_public_path__ + "img/resource-wx.f0585268.png";